import * as yup from 'yup';
import { Row, Column, EMPTY_ARRAY, RenderConfig, SelectInput } from 'commons-ui';
import { LOTTERY_POOL_ACTION_OPTIONS } from '../../lotteryUploadCsv/utils/constants';

export const FORM_FIELD_KEYS = {
	actionName: 'actionName'
};

export const FORM_LAYOUT_CREATE_CONFIG = [new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.actionName)])])];

export const FORM_FIELD_CREATE_CONFIG = {
	[FORM_FIELD_KEYS.actionName]: new RenderConfig()
		.setName('actionName')
		.setLabel('Select Action')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: LOTTERY_POOL_ACTION_OPTIONS
		})
};

export const validationSchema = yup.object().shape({
	message: yup
		.string()
		.test('len', 'Message should be of appropriate length!', (val) => !val || val.length > 1 || val.length < 50)
		.optional()
});
